import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/Sheet/Sheet";
import { CreateExplorationForm } from "../../forms/rotations/CreateExplorationForm";
import { format } from "date-fns";

const CreateExplorationSheet = ({
  open,
  onOpenChange,
  data,
  loadingTeachers,
  rotation,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  data: { rotations: any[]; sessions: any[]; teachers: any[] };
  loadingTeachers: boolean;
  rotation: any;
}) => {
  const onSuccess = () => {
    onOpenChange(false);
  };

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right">
        <SheetHeader>
          <SheetTitle>
            Create Exploration —{" "}
            {format(rotation.rotationDate, "MMMM dd, yyyy")}
          </SheetTitle>
          <SheetDescription>
            Create a new exploration for{" "}
            {format(rotation.rotationDate, "MMMM dd, yyyy")}.
          </SheetDescription>
        </SheetHeader>
        <CreateExplorationForm
          onSuccess={onSuccess}
          data={data}
          loadingTeachers={loadingTeachers}
          rotationId={rotation.rotationId}
        />
      </SheetContent>
    </Sheet>
  );
};

export { CreateExplorationSheet };
